import { Chip } from "@bracket/ui";
import styled from "styled-components";

export const StyledChip = styled.div<{ $color: "green" | "gray" }>`
  color: ${(props) => (props.$color === "green" ? "#57FF03" : "#C1C9BE")};
  background-color: ${(props) =>
    props.$color === "green" ? "#0e1e08" : "#1a1c1a"};
  padding: 0.25rem 1rem;
  border-radius: 1000px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Inter";
  font-weight: 400;
  font-size: 1rem;
`;
